import { render, staticRenderFns } from "./TestiLinguaTabs.vue?vue&type=template&id=3ac5b8b3&scoped=true"
import script from "./TestiLinguaTabs.vue?vue&type=script&lang=js"
export * from "./TestiLinguaTabs.vue?vue&type=script&lang=js"
import style0 from "./TestiLinguaTabs.vue?vue&type=style&index=0&id=3ac5b8b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac5b8b3",
  null
  
)

export default component.exports